'use client';
import React, { createContext } from 'react';
import type { CalculationStore } from './types';

/**
 * Empty rather than `undefined` by default: a block can legitimately render
 * outside any provider — a story, a test, an unpriced table — and must see no
 * data rather than throw.
 */
export const CalculationStoreContext = createContext<CalculationStore>({});

export const CalculationStoreProvider: React.FC<{
  value: CalculationStore;
  children: React.ReactNode;
}> = ({ value, children }) => (
  <CalculationStoreContext.Provider value={value}>
    {children}
  </CalculationStoreContext.Provider>
);
